import { path } from 'ramda'

export const isDABCaseEntry = entry => {
  let visible_to = path(['target', 'visible_to'], entry) || []
  let kindPath = ['kind']
  if (visible_to && !Array.isArray(visible_to)) {
    visible_to = visible_to.entries || []
    let kindPath = ['target', 'kind']
  }

  return (
    visible_to.filter(x => path(kindPath, x) === 'advisory_board').length > 0
  )
}

export const isAdminOfInvitedGroup = entry => {
  let visible_to = path(['target', 'visible_to'], entry) || []
  if (visible_to && !Array.isArray(visible_to)) {
    visible_to = visible_to.entries || []
  }

  return visible_to.filter(x => x['is_admin']).length > 0
}
